module.exports = __webpack_public_path__ + "img/T4-C-xh_9.793298a1.png";